import { Box, BoxProps, Stack, Text } from '@mantine/core';
import cx from 'clsx';
import { ComponentPropsWithoutRef, PropsWithChildren } from 'react';

import classes from './AppContent.module.css';

interface AppContentProps extends BoxProps, Pick<ComponentPropsWithoutRef<'div'>, 'role' | 'aria-label'> {
  type?: 'full' | 'outline';

  title?: string | null;
}

// TODO RENAME FROM AppContent to Content
export function Content(props: PropsWithChildren<AppContentProps>) {
  const { type = 'outline', children, title, ...rest } = props;
  return (
    <Box
      {...rest}
      p="sm"
      className={cx(classes.content, type === 'full' ? classes.full : classes.outline)}
    >
      <Stack>
        {title && <Text>{title}</Text>}
        {children}
      </Stack>
    </Box>
  );
}
